const selfApi = "http://159.69.86.178:5100";

//const selfApi = "http://localhost:5000";
export default selfApi;

export const selfUrl = "http://self-test.multinations.eu";
// export const selfUrl = "http://159.69.86.178:3100";
// export const selfUrl = "http://localhost:3000";
